import './App.css';

import { Admin, CustomRoutes, Resource } from 'react-admin';
import { Route } from 'react-router-dom';
import dataProvider from './Providers/dataProvider';
import authProvider from './Providers/authProvider';

import { Dashboard, Help } from './Pages';
import { AppLayout, appTheme, appDarkTheme } from './Layout';
import {
	Session,
	Interview,
	User,
	Group,
	Methodology,
	Outcome
} from './Resources';

function App() {
	
	return (
		<Admin
			dashboard={Dashboard}
			dataProvider={dataProvider}
			authProvider={authProvider}
			layout={AppLayout}
			theme={appTheme}
			darkTheme={appDarkTheme}
			defaultTheme='dark'
			disableTelemetry
			requireAuth
			>
			<Resource name="sessions"  {...Session} />
			<Resource name="interviews" {...Interview} options={{label: "Conversations"}} />
			<Resource name="methodologies" {...Methodology} />
			<Resource name="outcomes" {...Outcome} />
			<Resource name="groups" {...Group} />
			<Resource name="users" {...User} />

			<CustomRoutes>
				<Route path="/help" element={<Help />} />
			</CustomRoutes>
		</Admin>
	);
}

export default App;
